import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/anvil/casts/{castEid}/embed-url']['GET'];
type Input = ThisApi['params'];

const getAnvilCastEmbedUrl = async ({ castEid }: Input): Promise<ThisApi['response']> => {
  const data = await noodleApiClient.get(`/anvil/casts/${castEid}/embed-url`);
  return data.data;
};

export default getAnvilCastEmbedUrl;
